(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["city-bottom-page-list"] && !Shopify.designMode) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {
  const accordions = document.querySelectorAll(".accordion-title");
  const cityBottomPageList = document.querySelector(".city-bottom-page-list");

  function adjustPadding() {
    let maxHeight = 0;
    document.querySelectorAll(".accordion-content").forEach(function (content) {
      if (content.style.display === "block") {
        maxHeight = Math.max(maxHeight, content.offsetHeight);
      }
    });

    cityBottomPageList.style.paddingBottom = maxHeight ? `${maxHeight + 50}px` : "2rem";
  }

  accordions.forEach(function (btn) {
    btn.addEventListener("click", function () {
      let content = this.nextElementSibling;
      let allContents = document.querySelectorAll(".accordion-content");

      allContents.forEach(function (item) {
        if (item !== content) {
          item.style.display = "none";
        }
      });

      content.style.display = content.style.display === "block" ? "none" : "block";
      adjustPadding();
    });
  });

  window.addEventListener("resize", adjustPadding);
});

  } catch(e) { console.error(e); }
})();
})();
